export default __webpack_public_path__ + "static/media/Helm of Indomitable Souls.76c065f7.jpg";